// extracted by mini-css-extract-plugin
export default {"wrapper":"summary-card_wrapper__4iqbH","title":"summary-card_title__FrSJb","content":"summary-card_content__68Glo"};